import React from 'react';
import homeVideo from '../../videos/2022_AnnualReport_header.mp4';
import homeImage from '../../images/2022_AnnualReport_header.jpg';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";
import './Pages.css';

export default function Home()
{
	const navigate = useNavigate();

	return (
		<Container>
			<div className='mainSection' data-aos='fade' data-aos-duration='500' data-aos-delay='150' data-aos-offset="-5000" data-aos-once="true">
				<Row>
					<Col>
						<video width="100%" height="100%" playsInline autoPlay muted>
							<source src={homeVideo} type="video/mp4" />
						</video>
						<img alt="CACI Annual Report 2022" className='homeImage' src={homeImage} width="100%" />
					<div className='chapterArrows homeArrows text-center'>
						<Row>
							<Col sm={{ span: 2, offset: 5}} className='chapterArrow homeArrow' onClick={() => {navigate('/letterToOurShareholders'); window.scrollTo({ top:-100, left:0, behavior: "instant"});}}>
									<FontAwesomeIcon icon={faChevronRight} />
									<br/>
									<span>Next</span>
							</Col>
						</Row>
					</div>
					</Col>
				</Row>
			</div>
		</Container>
	);
}